import AppDialog from '../app_dialog'
import { Button, Combobox } from '@cinesend/ui-kit'
import { useQuery } from '@tanstack/react-query'
import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import useStore from '../../hooks/use_store'
import { convertToShorthandWithTimezone } from '../../helpers/convert_date'

function OpenModal({ cycleID, assetID, field, isLoading, value, onClose, saveField, refreshAsset }) {
  const params = useParams()
  const [stateValue, setStateValue] = useState(value)
  const { data, isLoading: isLoadingOptions } = useQuery([
    `media-info-files?assetID=${assetID}&airlineID=${params.airlineID}&fieldID=${field.id}`,
  ])
  const options = data
    ? data.map((option) => ({
        value: String(option.external_id),
        label: `${option.file_name} (${convertToShorthandWithTimezone(option.file.receivedTime)})`,
      }))
    : []
  const { updateModel, createModel, deleteModel } = useStore()

  useEffect(() => {
    if (data) {
      setStateValue(data.find((opt) => opt.file_name == value)?.external_id)
    }
  }, [data, value])

  const saveFileValue = (newValue) => {
    let data = {
      cycle_id: cycleID,
      asset_id: parseInt(assetID),
      value: newValue,
    }

    if (field.field_type === 'video') {
      saveVideoValue(data)
    } else if (field.field_type === 'audio') {
      saveAudioValue(data)
    } else {
      setMessage('Invalid field type')
    }
  }

  const saveVideoValue = (data) => {
    if (data.value === null) {
      deleteModel.mutate({
        endpoint: 'asset-videos',
        id: field.value.id,
        deleteNoun: 'video',
        deleteName: field.value.file_name || field.name,
        onSuccess: onSuccessHandler,
        onError: saveField,
      })
    } else if (field.value?.id) {
      updateModel.mutate({
        endpoint: 'asset-videos',
        id: field.value.id,
        data,
        onSuccess: onSuccessHandler,
        onError: saveField,
      })
    } else {
      data.field_id = field.id
      createModel.mutate({ endpoint: 'asset-videos', data, onSuccess: onSuccessHandler, onError: saveField })
    }
  }

  const saveAudioValue = (data) => {
    if (data.value === null) {
      deleteModel.mutate({
        endpoint: 'asset-audios',
        id: `${field.value.id}?cycle_id=${cycleID}`,
        deleteNoun: 'audio',
        deleteName: field.value.file_name || field.name,
        onSuccess: onSuccessHandler,
      })
    } else if (value) {
      updateModel.mutate({ endpoint: 'asset-audios', id: field.value.id, data, onSuccess: onSuccessHandler })
    } else {
      data.field_id = field.id
      createModel.mutate({ endpoint: 'asset-audios', data, onSuccess: onSuccessHandler })
    }
  }

  const onSuccessHandler = (res) => {
    saveField()
    refreshAsset()
  }

  return (
    <AppDialog
      title='Select file from external API'
      onClose={onClose}
      size='md'
      confirmText='Save'
      onConfirm={() => {
        saveFileValue(stateValue)
        onClose()
      }}
    >
      <Combobox
        label={field.name}
        disabled={isLoading || isLoadingOptions}
        value={stateValue ? String(stateValue) : null}
        options={options}
        clearable
        onValueChange={(selected) => setStateValue(selected)}
      />
    </AppDialog>
  )
}

export default function FileSelector({ cycleID, assetID, field, value, isLoading, saveField, refreshAsset }) {
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <div>
      <Button className='mt-[30px] min-w-40' variant='secondary' onClick={() => setModalOpen(true)}>
        Select File
      </Button>
      {modalOpen && (
        <OpenModal
          cycleID={cycleID}
          assetID={assetID}
          field={field}
          value={value}
          isLoading={isLoading}
          saveField={saveField}
          refreshAsset={refreshAsset}
          onClose={() => setModalOpen(false)}
        />
      )}
    </div>
  )
}
